/**
 * Given a value interpreted as text, determine whether to display it or not based on whether it is empty.
 * @param {*} text - A value to check. Will be interpreted as text, but can be any type.
 * @returns {boolean} - True if the textual representation of the value is non-empty.
 */
export default function displayText(text) {
  // Do a simple empty check on the text first.
  if (! text) {
    return false;
  }

  // If the value doesn't have a toString method, we can't test it properly.
  if ('function' !== typeof text.toString) {
    return false;
  }

  return '' !== text.toString();
}
